import React from "react";
import { cn } from "utils";
import type { GridTableColumn } from "./types";

interface GridCellProps {
  label?: string;
  value?: string;
  isTitle?: boolean;
  className?: string;
}

interface GridTableProps {
  dataSource: GridTableColumn[][];
  className?: string;
}

const GridCell: React.FC<GridCellProps> = ({
  label,
  value,
  isTitle = false,
  className,
}) => {
  if (isTitle) {
    return (
      <div
        className={cn(
          "flex items-center p-2",
          "bg-background_white_overlay5",
          "border-b-1 border-b-solid border-background_white_overlay10",
          className,
        )}
      >
        <p
          className={cn(
            "body_medium_s text-content_secondary whitespace-nowrap",
          )}
        >
          {label}
        </p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex items-center px-2 py-1.5",
        "border-b-1 border-b-solid border-background_white_overlay10",
        className,
      )}
    >
      <p className={cn("body_medium_m text-content_primary")}>{value}</p>
    </div>
  );
};

export const GridTable: React.FC<GridTableProps> = ({
  dataSource,
  className,
}) => {
  if (!dataSource || dataSource.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "border-1 border-solid border-background_white_overlay10 rounded-1",
        "overflow-hidden w-full flex flex-col",
        className,
      )}
    >
      {dataSource.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className={cn("grid w-full")}
          style={{ gridTemplateColumns: `repeat(${row.length}, 1fr)` }}
        >
          {row.map((col, colIndex) => (
            <GridCell
              key={`header-${rowIndex}-${colIndex}`}
              label={col.label}
              isTitle
              className={
                colIndex < row.length - 1
                  ? "border-r-1 border-r-solid border-r-background_white_overlay10"
                  : ""
              }
            />
          ))}

          {row.map((col, colIndex) => (
            <GridCell
              key={`value-${rowIndex}-${colIndex}`}
              value={col.value}
              className={cn(
                colIndex < row.length - 1
                  ? "border-r-1 border-r-solid border-r-background_white_overlay10"
                  : "",
                rowIndex === dataSource.length - 1 ? "!border-b-0" : "",
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
